import { type PublicClip } from '@air/api';
import { ClipUtils } from '@air/utils-clips';

import { useHandleContentCollectionClipMediaUpdated } from '~/components/ContentCollection/hooks/useHandleContentCollectionClipMediaUpdated';
import { useHandleContentCollectionClipUpdated } from '~/components/ContentCollection/hooks/useHandleContentCollectionClipUpdated';

export const useObserveTranscodingClipsUpdates = (clips: PublicClip[]) => {
  const transcodingClips = clips.filter((clip) => ClipUtils.isProcessing(clip.status));

  useHandleContentCollectionClipUpdated(transcodingClips);
  useHandleContentCollectionClipMediaUpdated(transcodingClips);
};
